import React from 'react';

export function SectionTitle({ icon: Icon, label, hint, action = null }) {
  return (
    <div className="flex items-center justify-between gap-3 mb-4">
      <div className="flex items-center gap-2.5 min-w-0">
        {Icon ? (
          <div className="h-9 w-9 rounded-xl bg-[var(--ns-gold)]/15 text-[var(--ns-gold-700)] inline-flex items-center justify-center shrink-0">
            <Icon className="h-4 w-4" />
          </div>
        ) : null}
        <div className="min-w-0">
          <h2 className="text-lg sm:text-xl font-semibold text-[var(--ns-text)] truncate">{label}</h2>
          {hint ? (
            <p className="text-xs text-[var(--ns-text-muted)] truncate">{hint}</p>
          ) : null}
        </div>
      </div>
      {action}
    </div>
  );
}
